import httpService from '@/modules/common/services/httpService';

const getOperatorBranding = async () => {
  try {
    const res = await httpService.post(`operator_api/v1/brand`, { host: window.location.hostname, new_api: true })

    return res
  } catch (e) {
    console.error(e)
  }

}

export default {
  getOperatorBranding,

}
